import { Trans } from '@lingui/react/macro';
import { cn, NoddiIcon } from 'noddi-ui-common';
import { formatPhoneNumber } from 'noddi-util';
import { ServiceCenterLocation } from '../ServiceCenter/ServiceCenterLocation';

type Props = {
  customerName?: string;
  customerPhoneNumber?: string;
  locationName: string;
  locationAddress?: { displayText: string; googleMapsUrl: string };
  /** Side by side from `md` up, stacked below it. */
  sideBySide?: boolean;
};

/**
 * Customer and service center as one block, shared by the proposal landing card
 * and the summary so both steps open on the same header rather than two shapes
 * of the same facts.
 */
export const ProposalCustomerAndLocation = ({
  customerName,
  customerPhoneNumber,
  locationName,
  locationAddress,
  sideBySide
}: Props) => (
  <div className={cn('flex flex-col gap-3', sideBySide && 'md:flex-row md:gap-6')}>
    {customerName && (
      <div className={cn('flex gap-2', sideBySide && 'md:min-w-0 md:flex-1')}>
        <NoddiIcon name='User' className='mt-0.5 shrink-0' />
        <div className='flex min-w-0 flex-col'>
          <span className='text-sm text-muted-foreground'>
            <Trans>Customer</Trans>
          </span>
          <span className='font-semibold'>{customerName}</span>
          {customerPhoneNumber && (
            <span className='text-sm text-muted-foreground'>{formatPhoneNumber(customerPhoneNumber)}</span>
          )}
        </div>
      </div>
    )}
    {locationAddress && (
      <ServiceCenterLocation
        name={locationName}
        address={locationAddress}
        showLabel
        className={cn(sideBySide && 'md:min-w-0 md:flex-1')}
      />
    )}
  </div>
);
